import {CheckoutLegacyMutationsCreateCartArgs, VolatileCartResponse} from '@wix/wixstores-graphql-schema-node';
import {STORES_APP_DEF_ID} from '@wix/wixstores-client-core/dist/src/constants';
import {ICustomTextFields} from '@wix/wixstores-client-core/dist/src/types/product';
import {IOnlineStoresViewerScript} from '@wix/wixstores-client-storefront-sdk';
import {TranslationDictionary} from '../types/app-types';
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor';

export class CheckoutApiService {
  constructor(
    private readonly wixCodeApi: any,
    private readonly errorHandler: ControllerFlowAPI['errorHandler'],
    private readonly translations: TranslationDictionary
  ) {}

  public async legacyCreateCheckout(
    createCartParams: CheckoutLegacyMutationsCreateCartArgs
  ): Promise<VolatileCartResponse> {
    const storesPublicApi: IOnlineStoresViewerScript['exports'] = await this.wixCodeApi.site.getPublicAPI(
      STORES_APP_DEF_ID
    );
    const checkout = await storesPublicApi.checkout.createCheckout(
      createCartParams.productId,
      createCartParams.quantity,
      {
        customTextFields: createCartParams.customTextFieldSelection as ICustomTextFields[],
        choices: createCartParams.options,
        optionsSelectionsIds: createCartParams.optionSelectionId,
        subscriptionOptionId: createCartParams.subscriptionOptionId,
        variantId: createCartParams.variantId,
      },
      createCartParams.preOrderRequested
    );

    return {checkoutId: checkout._id};
  }

  public async createCartV2(createCartParams: CheckoutLegacyMutationsCreateCartArgs): Promise<VolatileCartResponse> {
    const storesPublicApi: IOnlineStoresViewerScript['exports'] = await this.wixCodeApi.site.getPublicAPI(
      STORES_APP_DEF_ID
    );
    const {
      productId,
      quantity,
      options,
      optionSelectionId,
      customTextFieldSelection,
      subscriptionOptionId,
      variantId,
      preOrderRequested,
    } = createCartParams;

    const createCartRequest = () =>
      storesPublicApi.cart.createCart(
        productId,
        quantity,
        {
          customTextFields: customTextFieldSelection as ICustomTextFields[],
          choices: options,
          optionsSelectionsIds: optionSelectionId,
          subscriptionOptionId,
          variantId,
        },
        preOrderRequested
      );

    const {id} = await this.errorHandler.withErrorHandler(createCartRequest, {
      errorCodesMap: {
        applicationError: {
          ITEM_NOT_FOUND_IN_CATALOG: () => ({
            message: this.translations['productPage.addToCart.error.itemNotFound'],
          }),
          INSUFFICIENT_INVENTORY: () => ({
            message: this.translations['productPage.addToCart.error.insufficientInventory'],
          }),
        },
      },
    });
    return {checkoutId: id};
  }
}
